"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator from "../PrivilegedDropCreator";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
import { DropMode } from "../dropComposer.types";
import { WaveDropLayerProvider } from "../drops/WaveDropLayerContext";
import { useWaveEligibility } from "@/contexts/wave/WaveEligibilityContext";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(40);
  const {
    wave,
    drop,
    winningThreshold: t1,
    isVotingClosed: t2,
    isVotingControlsLocked: t3
  } = t0;
  const winningThreshold = t1 === undefined ? null : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  const {
    updateEligibility
  } = useWaveEligibility();
  const t4 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      paddingBottom: t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const inputContainerStyle = t5;
  let t6;
  if ($[2] !== drop) {
    t6 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[2] = drop;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const [activeDrop, setActiveDrop] = useState(t6);
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = t8 => {
      const {
        targetDrop,
        partId,
        action
      } = t8;
      setActiveDrop({
        action,
        drop: targetDrop,
        partId
      });
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const handleDropAction = t7;
  let t8;
  if ($[5] !== drop) {
    t8 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[5] = drop;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const resetActiveDrop = t8;
  let t9;
  if ($[7] !== updateEligibility || $[8] !== wave.chat || $[9] !== wave.id || $[10] !== wave.participation || $[11] !== wave.voting || $[12] !== wave.wave) {
    t9 = () => {
      updateEligibility(wave.id, {
        authenticated_user_eligible_to_chat: wave.chat.authenticated_user_eligible,
        authenticated_user_eligible_to_vote: wave.voting.authenticated_user_eligible,
        authenticated_user_eligible_to_participate: wave.participation.authenticated_user_eligible,
        authenticated_user_admin: wave.wave.authenticated_user_eligible_for_admin
      });
    };
    $[7] = updateEligibility;
    $[8] = wave.chat;
    $[9] = wave.id;
    $[10] = wave.participation;
    $[11] = wave.voting;
    $[12] = wave.wave;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== updateEligibility || $[15] !== wave) {
    t10 = [updateEligibility, wave];
    $[14] = updateEligibility;
    $[15] = wave;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  React.useEffect(t9, t10);
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      mobileMenuZIndexClassName: "tw-z-[1020]",
      mobileDialogZIndexClassName: "tw-z-[1030]"
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = t13 => {
      const {
        drop: repliedDrop,
        partId: partId_0
      } = t13;
      return handleDropAction({
        targetDrop: repliedDrop,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== activeDrop || $[20] !== drop.id || $[21] !== isVotingClosed || $[22] !== isVotingControlsLocked || $[23] !== wave || $[24] !== winningThreshold) {
    t13 = <div className="tw-min-h-0 tw-flex-1"><WaveDropsAll waveId={wave.id} wave={wave} onReply={t12} activeDrop={activeDrop} initialDrop={null} unreadCount={wave.metrics.your_unread_drops_count} dropId={drop.id} isMuted={wave.metrics.muted} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} /></div>;
    $[19] = activeDrop;
    $[20] = drop.id;
    $[21] = isVotingClosed;
    $[22] = isVotingControlsLocked;
    $[23] = wave;
    $[24] = winningThreshold;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== inputContainerStyle || $[27] !== isApp) {
    t14 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[26] = inputContainerStyle;
    $[27] = isApp;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== activeDrop || $[30] !== drop.id || $[31] !== resetActiveDrop || $[32] !== wave) {
    t15 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={DropMode.CHAT} /></CreateDropWaveWrapper>;
    $[29] = activeDrop;
    $[30] = drop.id;
    $[31] = resetActiveDrop;
    $[32] = wave;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <div style={t14} className="tw-mt-auto">{t15}</div>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <WaveDropLayerProvider value={t11}><div className="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-border-y-0 tw-border-l-0 tw-border-iron-800 tw-bg-iron-950 lg:tw-border lg:tw-border-r lg:tw-border-solid"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col">{t13}{t16}</div></div></div></div></div></WaveDropLayerProvider>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};